import React from 'react'
import { 
    StaticImage, 
    GatsbyImage, 
    // getImage 
} from "gatsby-plugin-image"

const Image = props => {
    let useNativeTag = true;
    if (props.useNativeTag) {
        useNativeTag = props.useNativeTag;
    }

    if (useNativeTag) {
        return <img {...props} alt={props.alt ? props.alt : ""} />
    }

    if (props.src.indexOf('/userfiles') > -1) {
        return <GatsbyImage image={props.src} {...props} />
    } else {
        return <StaticImage {...props} />
    }
}

export default Image;